import * as React from "react"
import { SVGProps, memo } from "react"

const SpeedControl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em" height="1em" viewBox="0 0 101 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#a)">
      <path
        d="M9.659 42.282c-.518 3.63-6.02 2.843-5.497-.811A46.896 46.896 0 0 1 19.79 12.83C27.924 5.739 38.556 1.445 50.127 1.445c5.237 0 10.274.881 14.985 2.5l-3.938 4.627a40.606 40.606 0 0 0-11.047-1.523A40.52 40.52 0 0 0 23.42 17.052a41.286 41.286 0 0 0-13.76 25.23Zm52.35 5.65a12.118 12.118 0 0 1-1.437 3.996c-3.328 5.813-10.714 7.789-16.48 4.449-5.7-3.32-7.548-11.199-4.427-16.651a12.046 12.046 0 0 1 2.755-3.288L72.64.981c2.013-2.337 5.74-.129 4.726 2.75L62.009 47.933Zm-8.632-7.807a6.478 6.478 0 0 0-8.9 2.401c-1.806 3.153-.767 7.165 2.377 8.997 2.937 1.855 7.217.556 8.914-2.41 1.806-3.153.736-7.168-2.39-8.988Zm25.346-28.737 1.744 1.44A46.915 46.915 0 0 1 96.092 41.47c.526 3.655-4.98 4.443-5.498.811a41.289 41.289 0 0 0-13.76-25.23l-.065-.058 1.954-5.604Z"
        fill="#fff"
      />
    </g>
    <defs>
      <filter
        id="a"
        x={0.127}
        y={0}
        width={100}
        height={66}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6092_9903"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_6092_9903"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

const MemoSpeedControl = memo(SpeedControl)
export default MemoSpeedControl
